import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'themeAsset',
  pure: false
})
export class ThemeAssetPipe implements PipeTransform {

  transform(value: string): string {
    const theme: string = document.body.getAttribute('data-theme');
    return `assets/${theme}/${value}`;
  }

}
